import { render, staticRenderFns } from "./local-presence-tool.vue?vue&type=template&id=2d921d29"
import script from "./local-presence-tool.vue?vue&type=script&lang=js"
export * from "./local-presence-tool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports